import { Action } from '@ngrx/store';

import {
  AnalyticsDataParamsInterface,
  TrackOlciFlowParamsInterface,
  TrackPayMethodParamsInterface
} from '../effects/interfaces';
import { label } from '../util';
import { AnalyticsTelemetryErrorData } from '../shared/interfaces';
import { TrackErrorPayload, TrackingFieldSelectionPayload } from '../models/action-payloads/tracking-payload';

export const TrackingActionTypes = {
	TRACK_PAGE_VIEW: label('[TRACK] Page View'),
	TRACK_LOGIN_EVENT: label('[TRACK] Login Event'),
	TRACK_LANDINGPAGE_VIEW: label('[TRACK] Landing Page Event View'),
	TRACK_GUESTS_CHECKING_IN_EVENT: label('[TRACK] Guests Checking In Event'),
	TRACK_EXPENSE_ACCOUNT_PAY_METHOD: label('[TRACK] Expense Account Pay Method'),
	TRACK_REPLACE_SAVED_CREDIT_CARD_EVENT: label('[TRACK] Replace Saved Credit Card Event'),
  TRACK_OLCI_START_EVENT: label('[TRACK] OLCI Start Flow Event'),
  TRACK_OLCI_COMPLETE_EVENT: label('[TRACK] OLCI Complete Flow Event'),
  TRACK_GUEST_PHOTO_EVENT: label('[TRACK] OLCI Update or Add Guest Photo'),
	TRACK_OLCI_FLOW_EVENT: label('[TRACK] OLCI Flow Event'),
  TRACK_SAVE_CARD_EVENT: label('[TRACK] OLCI Save Card Event'),
  TRACK_PAY_METHOD_EVENT: label('[TRACK] OLCI Pay Method Event'),
	TRACK_FIELD_ERROR_EVENT: label('[TRACK] Field Error Event'),
	TRACK_ERROR_PAGE_EVENT: label('[TRACK] Page Error Event'),
	TRACK_INLINE_ALERT_EVENT: label('[TRACK] Inline Alert Event'),
	TRACK_PAGE_INTERACTION_EVENT: label('[TRACK] Page Interaction Event'),
	TRACK_PAGE_CUSTOM_INTERACTION_EVENT: label('[TRACK] Page Custom Interaction Event'),
	TRACK_PRINT_SSP_EVENT: label('[TRACK] Print SSP Event'),
	TRACK_BACK_END_USER_ERRORS_EVENT: label('[TRACK] Back End User Errors Event'),
	TRACK_ERROR_PAGE_VIEW_EVENT: label('[TRACK] Error Page View Event'),
	TRACK_READY_TO_BOARD_VIEW: label('[TRACK] Ready to Board View Event'),
	TRACK_VISIT_HEALTH_CENTER_CLICK: label('[TRACK] Visit Health Center Click Event'),
	TRACK_HEALTH_CENTER_EXTERNAL_LINK_CLICK: label('[TRACK] Health Center External Link Click Event'),
	TRACK_CTC_TERM_PAGE_LINK_CLICK: label('[TRACK] CTC Terms Page External Link Click Event'),
  TRACK_INPUT_FIELD_SELECTION: label('[TRACK] Input Field Selection'),
	TRACK_GENERIC_ERROR_ALERT_EVENT: label('[TRACK] Generic Error And Alert Event'),
	TRACK_TELEMETRY_BACKEND_ERROR: label('[TRACK] Dispatch Backend Error Event'),
  TRACK_TELEMETRY_ERROR: label('[TRACK] Save telemetry error'),
	TRACK_CLEAR_TELEMETRY_ERROR: label('[TRACK] Clear telemetry error'),
	TRACK_FRONTEND_DEEP_LINK: label('[TRACK] Frontend Deep Link Event'),
};

export class TrackPageViewAction implements Action {
	type = TrackingActionTypes.TRACK_PAGE_VIEW;
}

export class TrackReadyToBoardViewAction implements Action {
	type = TrackingActionTypes.TRACK_READY_TO_BOARD_VIEW;
}

export class TrackVisitHealthCenterClickAction implements Action {
	type = TrackingActionTypes.TRACK_VISIT_HEALTH_CENTER_CLICK;
}

export class TrackHealthCenterExternalLinkClickAction implements Action {
	type = TrackingActionTypes.TRACK_HEALTH_CENTER_EXTERNAL_LINK_CLICK;
	constructor(public payload:any) {}
}

export class TrackLoginEventAction implements Action {
	type = TrackingActionTypes.TRACK_LOGIN_EVENT;
}

export class TrackLandingpageViewAction implements Action {
	type = TrackingActionTypes.TRACK_LANDINGPAGE_VIEW;
}

export class TrackGuestsCheckingInEventAction implements Action {
	type = TrackingActionTypes.TRACK_GUESTS_CHECKING_IN_EVENT;
	constructor(public payload: object) {}
}

export class TrackExpenseAccountPayMethodAction implements Action {
	type = TrackingActionTypes.TRACK_EXPENSE_ACCOUNT_PAY_METHOD;
	constructor(public payload: any) {}
}

export class TrackReplaceSavedCreditCardEventAction implements Action {
	type = TrackingActionTypes.TRACK_REPLACE_SAVED_CREDIT_CARD_EVENT;
	constructor(public payload: any) {}
}

export class TrackOlciStartEventAction implements Action {
  type = TrackingActionTypes.TRACK_OLCI_START_EVENT;
  constructor(public payload: TrackOlciFlowParamsInterface) {}
}

export class TrackGuestPhotoEventAction implements Action {
  type = TrackingActionTypes.TRACK_GUEST_PHOTO_EVENT;
  constructor(public payload: any) {}
}

export class TrackOlciCompleteEventAction implements Action {
  type = TrackingActionTypes.TRACK_OLCI_COMPLETE_EVENT;
  constructor(public payload: TrackOlciFlowParamsInterface) {}
}

export class TrackSaveCardEventAction implements Action {
  type = TrackingActionTypes.TRACK_SAVE_CARD_EVENT;
  constructor(public payload: TrackOlciFlowParamsInterface) {}
}

export class TrackPayMethodEventAction implements Action {
  type = TrackingActionTypes.TRACK_PAY_METHOD_EVENT;
  constructor(public payload: TrackPayMethodParamsInterface) {}
}

export class TrackOlciFlowEventAction implements Action {
	type = TrackingActionTypes.TRACK_OLCI_FLOW_EVENT;
	constructor(public payload: any) {}
}

export class TrackFieldErrorEventAction implements Action {
	type = TrackingActionTypes.TRACK_FIELD_ERROR_EVENT;
	constructor(public payload: any) {}
}

export class TrackPageErrorEventAction implements Action {
	type = TrackingActionTypes.TRACK_ERROR_PAGE_EVENT;
	constructor(public payload: TrackErrorPayload) {}
}

export class TrackInlineAlertEventAction implements Action {
	type = TrackingActionTypes.TRACK_INLINE_ALERT_EVENT;
	constructor(public payload: any) {}
}

export class TrackFrontendDeepLinkEventAction implements Action {
  type = TrackingActionTypes.TRACK_FRONTEND_DEEP_LINK;
  constructor(public payload: AnalyticsDataParamsInterface) {}
}

export class TrackPageInteractionEventAction implements Action {
	type = TrackingActionTypes.TRACK_PAGE_INTERACTION_EVENT;
	constructor(public payload: any) {}
}

export class TrackPageCustomInteractionEventAction implements Action {
	type = TrackingActionTypes.TRACK_PAGE_CUSTOM_INTERACTION_EVENT;
	constructor(public payload: object) {}
}

export class TrackPrintSSPEventAction implements Action {
	type = TrackingActionTypes.TRACK_PRINT_SSP_EVENT;
	constructor(public payload: any) {}
}

export class TrackBackEndUserErrorsEventAction implements Action {
	type = TrackingActionTypes.TRACK_BACK_END_USER_ERRORS_EVENT;
	constructor(public payload: object) {}
}

export class TrackErrorPageViewEventAction implements Action {
	type = TrackingActionTypes.TRACK_ERROR_PAGE_VIEW_EVENT;
}

export class TrackCTCTermPageExternalLinkClickAction implements Action {
	type = TrackingActionTypes.TRACK_CTC_TERM_PAGE_LINK_CLICK;
}

export class TrackInputFieldSelection implements Action {
  type = TrackingActionTypes.TRACK_INPUT_FIELD_SELECTION;
  constructor(public payload: TrackingFieldSelectionPayload) { }
}

export class TrackTelemetryBackendErrorAction implements Action {
	type = TrackingActionTypes.TRACK_TELEMETRY_BACKEND_ERROR;
	constructor(public payload: AnalyticsTelemetryErrorData) {}
}

export class TrackTelemetryErrorAction implements Action {
  type = TrackingActionTypes.TRACK_TELEMETRY_ERROR;
  constructor(public payload: any) {}
}

export class TrackClearTelemetryErrorAction implements Action {
	type = TrackingActionTypes.TRACK_CLEAR_TELEMETRY_ERROR;
}

export type TrackingActions =
	| TrackPageViewAction
	| TrackLoginEventAction
	| TrackLandingpageViewAction
	| TrackGuestsCheckingInEventAction
	| TrackExpenseAccountPayMethodAction
	| TrackOlciFlowEventAction
	| TrackFieldErrorEventAction
	| TrackPageErrorEventAction
	| TrackInlineAlertEventAction
	| TrackPageInteractionEventAction
	| TrackPageCustomInteractionEventAction
	| TrackPrintSSPEventAction
	| TrackBackEndUserErrorsEventAction
	| TrackErrorPageViewEventAction
	| TrackCTCTermPageExternalLinkClickAction
	| TrackReplaceSavedCreditCardEventAction
	| TrackInputFieldSelection
	| TrackTelemetryBackendErrorAction
	| TrackTelemetryErrorAction
	| TrackClearTelemetryErrorAction;
